import React from "react";
import styled from "styled-components";

import Statistics from "./statistics";
import WeeklyReport from "./weeklyReport";

const Top = () => {
  return (
    <Container>
      <StatisticsContainer>
        <Statistics />
      </StatisticsContainer>
      <WeeklyContainer>
        <WeeklyReport />
      </WeeklyContainer>
    </Container>
  );
};

export default Top;

const Container = styled.div`
  width: 100%;
  background: #1e1e1e;
  height: 50rem;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 769px) {
    flex-direction: column;
    height: fit-content;
  }
`;

const StatisticsContainer = styled.div`
  width: 60%;
  height: 100%;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: fit-content;
  }
`;

const WeeklyContainer = styled.div`
  width: 40%;
  height: 100%;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: fit-content;
  }
`;
